export default __webpack_public_path__ + "static/media/CHARGING.f9e8a0a0.png";